/**
 * PDP V2 — JavaScript
 * All logic scoped to .pdp-v2 master class
 * Safe to load alongside v1 – no global pollution
 */

(function () {
  'use strict';

  // Guard: only run if v2 is on the page
  const ROOT = document.querySelector('.pdp-v2');
  if (!ROOT) return;

  /* ============================================================
     GALLERY
     ============================================================ */
  const GALLERY = {
    container: ROOT.querySelector('.pdp2-gallery-slides'),
    slides: [],
    thumbsRail: ROOT.querySelectorAll('.pdp2-thumb-rail .pdp2-thumb-item'),
    thumbsStrip: ROOT.querySelectorAll('.pdp2-thumb-strip .pdp2-thumb-item'),
    dots: ROOT.querySelectorAll('.pdp2-gallery-dot'),
    prevBtn: ROOT.querySelector('.pdp2-gallery-btn--prev'),
    nextBtn: ROOT.querySelector('.pdp2-gallery-btn--next'),
    current: 0,

    init() {
      if (!this.container) return;
      this.slides = Array.from(this.container.querySelectorAll('.pdp2-gallery-slide'));
      if (!this.slides.length) return;

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.current - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.current + 1));

      this.thumbsRail.forEach((t, i) => t.addEventListener('click', () => this.go(i)));
      this.thumbsStrip.forEach((t, i) => t.addEventListener('click', () => this.go(i)));
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));

      // Touch / swipe
      let startX = 0;
      this.container.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
      this.container.addEventListener('touchend', e => {
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) this.go(dx < 0 ? this.current + 1 : this.current - 1);
      }, { passive: true });

      // Zoom modal on click
      this.slides.forEach((slide) => {
        const img = slide.querySelector('img');
        if (img) img.addEventListener('click', () => {
          ZOOMMODAL.open(slide.dataset.mediaId);
        });
      });

      this.go(0, false);
    },

    go(index, animate = true) {
      const len = this.slides.length;
      this.current = ((index % len) + len) % len;
      if (animate) {
        this.container.style.transition = 'transform 0.35s cubic-bezier(0.4,0,0.2,1)';
      } else {
        this.container.style.transition = 'none';
      }
      this.container.style.transform = `translateX(-${this.current * 100}%)`;

      this.thumbsRail.forEach((t, i) => t.classList.toggle('is-active', i === this.current));
      this.thumbsStrip.forEach((t, i) => t.classList.toggle('is-active', i === this.current));
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.current));
    },

    // Called when variant changes to jump to that variant's image index
    goToMediaId(mediaId) {
      const idx = this.slides.findIndex(s => s.dataset.mediaId == mediaId);
      if (idx > -1) this.go(idx);
    }
  };

  /* ============================================================
     LIGHTBOX
     ============================================================ */
    const ZOOMMODAL = {
    el: document.getElementById('pdp2-zoom-modal'),
    closeBtn: null,

    init() {
      if (!this.el) return;
      this.closeBtn = this.el.querySelector('.pdp2-zoom-modal__close');
      this.closeBtn && this.closeBtn.addEventListener('click', () => this.close());
      // close on backdrop (clicking outside content)
      this.el.addEventListener('click', e => {
        if (e.target === this.el) this.close();
      });
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') this.close();
      });
    },

    open(mediaId) {
      if (!this.el) return;
      this.el.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      if (mediaId) {
        const target = this.el.querySelector(`[data-media-id="${mediaId}"]`);
        if (target) {
          setTimeout(() => target.scrollIntoView({ block: 'start' }), 50);
        }
      } else {
        this.el.querySelector('.pdp2-zoom-modal__content').scrollTop = 0;
      }
    },

    close() {
      if (!this.el) return;
      this.el.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }
  };
  const SIZECHART = {
    trigger: ROOT.querySelector('[data-size-chart-trigger]'),
    overlay: ROOT.querySelector('.pdp2-sizechart-overlay'),
    closeBtn: ROOT.querySelector('.pdp2-sizechart-close'),

    init() {
      if (!this.trigger || !this.overlay) return;
      this.trigger.addEventListener('click', () => this.open());
      this.closeBtn && this.closeBtn.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', e => { if (e.target === this.overlay) this.close(); });
      document.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
    },

    open() {
      this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },

    close() {
      this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  };
  /* ============================================================
     TABS
     ============================================================ */
  const TABS = {
    btns: ROOT.querySelectorAll('.pdp2-tab-btn'),
    panels: ROOT.querySelectorAll('.pdp2-tab-panel'),

    init() {
      if (!this.btns.length) return;
      this.btns.forEach(btn => {
        btn.addEventListener('click', () => this.activate(btn.dataset.tab));
      });
    },

    activate(id) {
      this.btns.forEach(b => b.classList.toggle('is-active', b.dataset.tab === id));
      this.panels.forEach(p => p.classList.toggle('is-active', p.dataset.panel === id));
    }
  };

  /* ============================================================
     VARIANTS
     ============================================================ */
  const VARIANTS = {
    priceEl: ROOT.querySelector('.pdp2-price-current'),
    compareEl: ROOT.querySelector('.pdp2-price-compare'),
    saveBadge: ROOT.querySelector('.pdp2-price-save'),
    addBtn: ROOT.querySelector('.pdp2-btn-add'),
    ctaRow: ROOT.querySelector('.pdp2-cta-flex-row'),
    qtyStandalone: ROOT.querySelector('.pdp2-qty-standalone'),

    init() {
      ROOT.querySelectorAll('variant-radios, variant-selects').forEach(el => {
        el.addEventListener('change', () => {
          // global.js updates el.currentVariant synchronously on change,
          // but the fetch/render it triggers is async — wait a tick.
          setTimeout(() => this.onVariantChange(el), 0);
        });
      });
    },

    onVariantChange(el) {
      const variant = el.currentVariant;
      if (!variant) return;

      // Sync the real buy-buttons form's hidden id input
      // (global.js can't reach across blocks to update it)
      const realIdInput = document.querySelector('.pdp2-real-buybuttons form input[name="id"]');
      if (realIdInput) realIdInput.value = variant.id;

      this.updatePrice(variant);
      this.updateAvailability(variant);
      this.updateSelectedLabels(variant);

      if (variant.featured_media) {
        GALLERY.goToMediaId(variant.featured_media.id);
      }
    },

    updatePrice(variant) {
      const fmt = window.Shopify && window.Shopify.formatMoney
        ? (cents) => Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat || '{{amount}}')
        : (cents) => '$' + (cents / 100).toFixed(2);

      if (this.priceEl) this.priceEl.textContent = fmt(variant.price);

      if (this.compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          this.compareEl.textContent = fmt(variant.compare_at_price);
          this.compareEl.style.display = '';
          if (this.saveBadge) {
            const pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
            this.saveBadge.textContent = `SAVE ${pct}%`;
            this.saveBadge.style.display = '';
          }
        } else {
          this.compareEl.style.display = 'none';
          if (this.saveBadge) this.saveBadge.style.display = 'none';
        }
      }
    },

    updateAvailability(variant) {
      const available = variant.available;
      if (this.addBtn) this.addBtn.disabled = !available;
      if (this.ctaRow) this.ctaRow.classList.toggle('is-sold-out', !available);
      if (this.qtyStandalone) this.qtyStandalone.classList.toggle('is-sold-out', !available);
    },

    updateSelectedLabels(variant) {
      const opts = ['option1', 'option2', 'option3'];
      ROOT.querySelectorAll('.pdp2-option-label[data-option-index]').forEach(label => {
        const idx = parseInt(label.dataset.optionIndex);
        const val = variant[opts[idx]];
        const valSpan = label.querySelector('.pdp2-selected-val');
        if (valSpan && val != null) {
          valSpan.textContent = ': ' + val;
        }
      });
    }
  };

  /* ============================================================
     QUANTITY BOX
     ============================================================ */
  function initQtyBoxes() {
    ROOT.querySelectorAll('.pdp2-qty-box').forEach(box => {
      const input = box.querySelector('input');
      if (!input) return;
      box.querySelector('.pdp2-qty-minus').addEventListener('click', () => {
        const v = parseInt(input.value) || 1;
        if (v > 1) { input.value = v - 1; syncQtyInputs(input); }
      });
      box.querySelector('.pdp2-qty-plus').addEventListener('click', () => {
        input.value = (parseInt(input.value) || 1) + 1;
        syncQtyInputs(input);
      });
      input.addEventListener('change', () => syncQtyInputs(input));
    });
  }

  function syncQtyInputs(changed) {
    // Sync all qty inputs to the same value
    ROOT.querySelectorAll('.pdp2-qty-box input').forEach(inp => {
      inp.value = changed.value;
    });
    // Sync the real buy-buttons form's quantity input
    const realQty = ROOT.querySelector('.pdp2-real-buybuttons input[name="quantity"]');
    if (realQty) realQty.value = changed.value;
  }

  /* ============================================================
     ADD TO CART / BUY NOW
     ============================================================ */
  function initCartButtons() {
    ROOT.querySelectorAll('.pdp2-btn-add').forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        const realForm = ROOT.querySelector('.pdp2-real-buybuttons form');
        const realSubmit = ROOT.querySelector('.pdp2-real-buybuttons button[name="add"]');
        if (realForm && realSubmit) {
          const qty = ROOT.querySelector('.pdp2-qty-box input')?.value || '1';
          let qtyInput = realForm.querySelector('input[name="quantity"]');
          if (!qtyInput) {
            qtyInput = document.createElement('input');
            qtyInput.type = 'hidden';
            qtyInput.name = 'quantity';
            realForm.appendChild(qtyInput);
          }
          qtyInput.value = qty;

          btn.classList.add('is-loading');
          realSubmit.click();
          setTimeout(() => btn.classList.remove('is-loading'), 2500);
        }
      });
    });
  }

  /* ============================================================
     REVIEWS SCROLL
     ============================================================ */
  function initReviewScroll() {
    ROOT.querySelectorAll('.pdp2-rating-count, a[href="#pdpfadinid"]').forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault();
        const target = ROOT.querySelector('.pdp2-reviews-section') || document.querySelector('#pdpfadinid');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ============================================================
     WISHLIST SYNC (re-uses existing WHL logic)
     ============================================================ 
  function initWishlist() {
    ROOT.querySelectorAll('.pdp2-wishlist-btn').forEach(btn => {
      const tooltip = btn.querySelector('.pdp2-wish-tooltip');

      btn.addEventListener('click', () => {
        const pid = btn.dataset.productId;
        if (!pid) return;

        const existingBtn = document.querySelector(`.WHL_addBtn[data-wishlistid="${pid}"]`);
        if (existingBtn) existingBtn.click();

        const isWished = btn.classList.toggle('is-wished');

        // Update tooltip text based on new state
        if (tooltip) tooltip.textContent = isWished ? 'Added to Wishlist' : 'Removed from Wishlist';

        // Show tooltip
        if (tooltip) {
          tooltip.classList.add('is-visible');
          clearTimeout(btn._wishTimer);
          btn._wishTimer = setTimeout(() => {
            tooltip.classList.remove('is-visible');
          }, 2500);
        }
      });
    });
  } */

  /* ============================================================
     FIX: rogue cart:refresh (3rd-party chat widget) leaves
     <cart-drawer-items class="is-empty"> stuck even when items
     exist — causes drawer to visually "go blank" after ~1.5s.
     ============================================================ */
    function initCartDrawerEmptyClassFix() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      var cartEmpty = false;

      // On cart:refresh fetch real cart state
      document.addEventListener('cart:refresh', function() {
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var cdi = document.querySelector('cart-drawer-items');
            cartEmpty = cart.item_count === 0;
            if (cart.item_count > 0) {
              // Items exist — rogue refresh marked drawer empty, fix it
              if (cdi) cdi.classList.remove('is-empty');
              drawer.classList.remove('is-empty');
            }
          });
      });

      // Watch drawer class — if cart is truly empty and is-empty gets removed, put it back instantly
      new MutationObserver(function() {
        if (cartEmpty && !drawer.classList.contains('is-empty')) {
          drawer.classList.add('is-empty');
          var cdi = document.querySelector('cart-drawer-items');
          if (cdi) cdi.classList.add('is-empty');
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    /* ============================================================
     A+ IMAGE — show more / show less toggle
     ============================================================ */
    function initAplusToggle() {
      ROOT.querySelectorAll('[data-aplus-toggle]').forEach(btn => {
        const target = document.getElementById(btn.dataset.aplusToggle);
        if (!target) return;

        btn.addEventListener('click', () => {
          const expanded = target.classList.toggle('is-expanded');
          btn.textContent = expanded ? 'Show less' : 'Show more';
        });
      });
    }

    function initCartErrorWatch() {
      var origFetch = window.fetch;
      window.fetch = function(url, options) {
        var result = origFetch.apply(this, arguments);
        if (typeof url === 'string' && url.includes('/cart/add')) {
          result.then(function(res) {
            var clone = res.clone();
            clone.json().then(function(data) {
              var existing = ROOT.querySelector('.pdp2-qty-error-msg');
              if (existing) existing.remove();

              if (data.status === 422 && data.description) {
                var qtyBox = ROOT.querySelector('.pdp2-qty-standalone');
                var msg = document.createElement('p');
                msg.className = 'pdp2-qty-error-msg';
                msg.textContent = data.description;
                msg.style.cssText = 'color:#c0392b;font-size:13px;margin-top:8px;font-weight:500;';
                if (qtyBox) qtyBox.insertAdjacentElement('afterend', msg);
                setTimeout(function() { if (msg.parentNode) msg.remove(); }, 5000);
              }
            }).catch(function(){});
          });
        }
        return result;
      };
    }
    /* ============================================================
     INIT ALL
     ============================================================ */
  function init() {
    GALLERY.init();
    ZOOMMODAL.init();
    SIZECHART.init(); 
    TABS.init();
    VARIANTS.init();
    initQtyBoxes();
    initCartButtons();
    initCartDrawerEmptyClassFix(); 
    initAplusToggle(); 
    initReviewScroll();
    initCartErrorWatch();

    // Promo offer swiper
    (function() {
      var wrap = document.querySelector('.pdp2-promo-swiper-wrap');
      if (!wrap) return;
      if (typeof Swiper === 'undefined') return;
      var sw = new Swiper(wrap.querySelector('.pdp2-promo-swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 12,
        loop: false,
        allowTouchMove: true,
      });
      var prev = wrap.querySelector('.pdp2-promo-arrow--prev');
      var next = wrap.querySelector('.pdp2-promo-arrow--next');
      if (window.innerWidth > 767 && sw.slides.length > 1) {
        if (prev) prev.classList.add('is-visible');
        if (next) next.classList.add('is-visible');
        sw.on('slideChange', function() {
          if (prev) prev.classList.toggle('swiper-button-disabled', sw.isBeginning);
          if (next) next.classList.toggle('swiper-button-disabled', sw.isEnd);
        });
        // Set initial state
        if (prev) prev.classList.toggle('swiper-button-disabled', sw.isBeginning);
        if (next) next.classList.toggle('swiper-button-disabled', sw.isEnd);
      } else {
        if (prev) prev.style.display = 'none';
        if (next) next.style.display = 'none';
      }
      if (prev) prev.addEventListener('click', function() { sw.slidePrev(); });
      if (next) next.addEventListener('click', function() { sw.slideNext(); });
    })();


    // Variant active state — re-apply after variant-radios re-renders
    ROOT.querySelectorAll('variant-radios, variant-selects').forEach(function(vr) {
      new MutationObserver(function() {
        // After re-render, find the checked radio and mark its label active
        vr.querySelectorAll('input[type="radio"]:checked').forEach(function(input) {
          var fieldset = input.closest('fieldset');
          if (!fieldset) return;
          fieldset.querySelectorAll('.pdp2-variant-btn, .pdp2-color-swatch').forEach(function(el) {
            el.classList.remove('is-active');
          });
          var label = fieldset.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.add('is-active');
        });
      }).observe(vr, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function injectShadowStyle(el) {
  if (!el.shadowRoot) return;
  const style = document.createElement('style');
  style.textContent = `.accelerated-checkout-button { min-width: auto !important; }`;
  el.shadowRoot.appendChild(style);
}

const observer = new MutationObserver(() => {
  document.querySelectorAll('shopify-google-pay-button').forEach(el => {
    if (el.shadowRoot && !el.dataset.styleInjected) {
      injectShadowStyle(el);
      el.dataset.styleInjected = 'true';
    }
  });
});

observer.observe(document.body, { childList: true, subtree: true });

// Also run immediately in case already mounted
document.querySelectorAll('shopify-google-pay-button').forEach(el => {
  if (el.shadowRoot) {
    injectShadowStyle(el);
    el.dataset.styleInjected = 'true';
  }
});

})();
